import axios from 'axios'
import { AxiosInterceptor } from '../Config/AxiosInterceptor'
import { employeeSalaryType } from './../Pages/Frontend/Interface/Admin/Users/UsersDetails/UsersDetails'

AxiosInterceptor()

export const salaryService = {
  createSalary: async (data: employeeSalaryType) => {
    return await axios.post('admin/employee/salary', data)
  },
  getSalary: async (employeeId: string | undefined) => {
    return await axios.get(
      `admin/employee/salary/get-salaries?pageNumber=1&employeeUserId=${employeeId}`,
    )
  },
  getSalaryV2: async (employeeId: string | undefined) => {
    return await axios.get(
      `admin/employee/salary/get-salaries?pageNumber=1&userId=${employeeId}`,
    )
  },

  getEmployeeSalary: async () => {
    return await axios.get('employee/salary')
  },
}
